
import React from "react";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

const Subscription = () => {
  const { user } = useAuth();

  const resources = [
    {
      title: "Biblioteca de Prompts",
      description: "Acesse todos os prompts otimizados para profissionais jurídicos.",
      features: [
        "Filtro por área do direito",
        "Exemplos práticos de uso",
        "Atualizações frequentes",
        "Acesso completo a todos os prompts"
      ],
      link: "/dashboard/prompts"
    },
    {
      title: "Material de Apoio",
      description: "Conteúdos educacionais sobre o uso de IA no direito.",
      features: [
        "Guias passo a passo",
        "Melhores práticas",
        "Dicas de produtividade",
        "Casos de uso reais"
      ],
      link: "/how-to-use"
    }
  ];

  return (
    <DashboardLayout title="Recursos Disponíveis">
      <div className="max-w-4xl mx-auto">        
        <div className="mb-8">
          <h2 className="text-xl font-medium mb-2">Bem-vindo aos recursos completos</h2>
          <p className="text-gray-600">
            Nossa plataforma oferece acesso gratuito a todos os recursos. Explore as opções abaixo para otimizar seu trabalho.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {resources.map((resource, index) => (
            <Card key={index} className="border border-gray-200">
              <CardHeader>
                <CardTitle>{resource.title}</CardTitle>
                <CardDescription>{resource.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 mb-6">
                  {resource.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center">
                      <Check className="h-4 w-4 mr-2 text-green-500" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button asChild className="w-full">
                  <Link to={resource.link}>Acessar</Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-medium mb-2">Recursos Exclusivos para Membros</h3>
          <p className="text-gray-600 mb-4">
            Como membro registrado, você tem acesso a todos os recursos da plataforma sem nenhuma restrição.
          </p>
          <ul className="space-y-3">
            <li className="flex items-start">
              <Check className="h-5 w-5 mr-2 text-green-500 flex-shrink-0 mt-0.5" />
              <span>
                <strong>Acesso Total:</strong> Use todos os prompts sem restrições de quantidade.
              </span>
            </li>
            <li className="flex items-start">
              <Check className="h-5 w-5 mr-2 text-green-500 flex-shrink-0 mt-0.5" />
              <span>
                <strong>Prompts Avançados:</strong> Acesso a prompts sofisticados para casos complexos.
              </span>
            </li>
            <li className="flex items-start">
              <Check className="h-5 w-5 mr-2 text-green-500 flex-shrink-0 mt-0.5" />
              <span>
                <strong>Suporte por Email:</strong> Receba ajuda e esclarecimentos da nossa equipe.
              </span>
            </li>
            <li className="flex items-start">
              <Check className="h-5 w-5 mr-2 text-green-500 flex-shrink-0 mt-0.5" />
              <span>
                <strong>Atualizações Constantes:</strong> Acesse novos prompts e melhorias assim que são lançados.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Subscription;
